import { useEffect, useContext } from 'react';
import { AuthContext } from 'context/auth-context';
import { Get_Token } from 'resolvers/Get_Token';
import * as JWT from 'jsonwebtoken';
import { Auth } from 'lib/api';
import { Token } from 'resolvers/Token';
import { RemoveTokenFromLS } from 'resolvers/RemoveTokenFromLS';
import apiService from 'lib/api/apiService';
import { getPublicSettings } from 'lib/api/settings';

function useAuth() {
    const { decodeState, setServerDown, setPublicKey, publicKey, setDecodeState, setPublicSettings } = useContext(AuthContext);
    useEffect(() => {
        apiService
            .get('/publickey')
            .then(response => {
                setPublicKey(response.data);
            })
            .catch(error => {
                setServerDown(true);
            });
    }, [setPublicKey, setServerDown]);

    useEffect(() => {
        getPublicSettings().then(response => {
            setPublicSettings(response);
        });
    }, [setPublicSettings]);

    useEffect(() => {
        if (!publicKey) {
            return;
        }
        let token = Get_Token();
        if (!token) {
            setDecodeState({
                loaded: true
            });
            return;
        }
        try {
            const decode = JWT.verify(token, publicKey);
            setDecodeState({
                ...decode,
                loaded: true
            });
        } catch (error) {
            if (error.name === 'TokenExpiredError') {
                Auth.refreshToken()
                    .then(response => {
                        Token(response);
                        const decode = JWT.decode(response.token);
                        setDecodeState({
                            ...decode,
                            loaded: true
                        });
                    })
                    .catch(() => {
                        RemoveTokenFromLS();
                        setDecodeState({
                            loaded: true
                        });
                        return;
                    });
            } else {
                RemoveTokenFromLS();
                setDecodeState({
                    loaded: true
                });
                return;
            }
        }
    }, [publicKey, setDecodeState]);

    return decodeState;
}

export default useAuth;
